module.exports = __webpack_public_path__ + "media/images/themes/mandy/6-77768d45f5e81053b0e932b3c6e5f3c7.jpg";